export default class {
    _id;
    _groupCode;
    _groupNameRu;
    _groupNameUz;
    _classCode;
    _classNameRu;
    _classNameUz;


    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get groupCode() {
        return this._groupCode
    }

    set groupCode(value) {
        this._groupCode = value
    }

    get groupNameRu() {
        return this._groupNameRu
    }

    set groupNameRu(value) {
        this._groupNameRu = value
    }

    get groupNameUz() {
        return this._groupNameUz
    }

    set groupNameUz(value) {
        this._groupNameUz = value
    }

    get classCode() {
        return this._classCode
    }

    set classCode(value) {
        this._classCode = value
    }

    get classNameRu() {
        return this._classNameRu
    }

    set classNameRu(value) {
        this._classNameRu = value
    }

    get classNameUz() {
        return this._classNameUz
    }

    set classNameUz(value) {
        this._classNameUz = value
    }

}